import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

function svgFallback(name = "?") {
  const initial = (name?.[0] || "?").toUpperCase();
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64">
      <rect width="100%" height="100%" fill="#444"/>
      <text x="50%" y="50%" dominant-baseline="middle"
            text-anchor="middle" font-size="32"
            fill="#fff" font-family="Arial, sans-serif">${initial}</text>
    </svg>`;
  return `data:image/svg+xml;base64,${window.btoa(
    unescape(encodeURIComponent(svg))
  )}`;
}

const truncateUsername = (str, max = 20) => {
  const s = String(str ?? "");
  const chars = Array.from(s);
  return chars.length > max ? chars.slice(0, max).join("") + "…" : s;
};

const cosmeticAssetSrc = (value) => {
  const v = String(value || "").trim();
  if (!v) return null;

  if (v.startsWith("/") || v.startsWith("http://") || v.startsWith("https://")) {
    return v;
  }

  return `/name-cosmetics/${v}`;
};

const getNameStyleCSS = (styleValue) => {
  const v = String(styleValue || "").trim().toLowerCase();

  if (v === "gold" || v === "golden") {
    return {
      backgroundImage: "linear-gradient(90deg, #fff2a8, #ffcc33, #ff8c00)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent",
      WebkitTextFillColor: "transparent",
    };
  }

  if (v === "ice" || v === "frost") {
    return {
      backgroundImage: "linear-gradient(90deg, #ffffff, #8eeaff, #2f8cff)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent",
      WebkitTextFillColor: "transparent",
    };
  }

  if (v === "toxic" || v === "green") {
    return {
      backgroundImage: "linear-gradient(90deg, #dfff7a, #47ff5a, #00b341)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent",
      WebkitTextFillColor: "transparent",
    };
  }

  if (v === "fire" || v === "flame") {
    return {
      backgroundImage: "linear-gradient(90deg, #fff06a, #ff7a18, #ff1e1e)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent",
      WebkitTextFillColor: "transparent",
    };
  }

  if (v === "style.png" || v === "shadow" || v === "dark") {
    return {
      backgroundImage: "linear-gradient(90deg, #d9d2ff, #8b5cff, #2d145c)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent",
      WebkitTextFillColor: "transparent",
    };
  }

  return {};
};

const statStyle2 = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  fontSize: 21,
  width: 94,
  height: 74,
  backgroundImage: "url('/s2square.png')",
  backgroundSize: "94px 74px",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  gap: 3,
  position: "relative",
};

const statGrid = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: 15,
  maxWidth: 320,
  margin: "0 auto",
};

export default function Referrals({ user, setUser, onClose, onNavigate }) {
  const [view, setView] = useState("leaderboard");

  const [leaderboardEntries, setLeaderboardEntries] = useState([]);
  const [leaderboardLoading, setLeaderboardLoading] = useState(true);
  const [leaderboardError, setLeaderboardError] = useState("");
  const [myRecruiterRank, setMyRecruiterRank] = useState(null);

  const [friends, setFriends] = useState([]);
  const [friendsLoading, setFriendsLoading] = useState(true);
  const [friendsError, setFriendsError] = useState("");

  const [pageSize] = useState(100);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const [referralLink, setReferralLink] = useState("");
  const [copied, setCopied] = useState(false);

const [referralsStreak, setReferralsStreak] = useState({
  enabled: false,
  startDate: null,
  endDate: null,
  priceRunes: 0,
  milestoneCount: 0,
  itemId: null,
  itemName: null,
  itemType: null,
  reward: null,
  seasonNumber: null,
  progress: 0,
  claimed: false,
  claimable: false,
  milestones: [],
});

  const [claimLoading, setClaimLoading] = useState(false);
  const [showClaimSuccessModal, setShowClaimSuccessModal] = useState(false);
  const [claimedRewards, setClaimedRewards] = useState({
    sparks: 0,
    runes: 0,
  });
  const [showClaimErrorModal, setShowClaimErrorModal] = useState(false);
  const [claimErrorMessage, setClaimErrorMessage] = useState("");

  const [pendingRewards, setPendingRewards] = useState({
  sparks: 0,
  runes: 0,
});

  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  const [showClaimStreakSuccessModal, setShowClaimStreakSuccessModal] = useState(false);
const [claimedStreakReward, setClaimedStreakReward] = useState({
  itemId: null,
  itemName: "",
  itemType: null,
  reward: null,
});

  const getRankIcon = (rank) => {
  if (rank === 0) return "/1.png";
  if (rank === 1) return "/2.png";
  if (rank === 2) return "/3.png";
  return `#${rank + 1}`;
};

  useEffect(() => {
    let cancelled = false;

   async function loadRecruiters() {
  const offset = (page - 1) * pageSize;
  setLeaderboardLoading(true);
  setLeaderboardError("");

  try {
    const url = `${process.env.REACT_APP_API_URL}/api/season-stats/recruiters-leaderboard?limit=${pageSize}&offset=${offset}`;

    const res = await fetch(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    const json = await res.json();
    const raw = Array.isArray(json?.items) ? json.items : [];
    const totalFromApi = Number(json?.total ?? 0);

    const cleaned = raw.map((r) => ({
  id: r.id ?? r.user_id ?? r.userId,
  username: r.username ?? r.name ?? "Unknown",
  recruits: Number(r.recruits ?? r.referrals ?? 0),
  avatar: r.avatarUrl ?? r.avatar_url,
  early_bird: r.early_bird,
  gamepass_active: r.gamepass_active,

  activeNameStyle: r.active_name_style ?? r.activeNameStyle ?? null,
  activeNameBanner: r.active_name_banner ?? r.activeNameBanner ?? null,
  activeNameEmogy: r.active_name_emogy ?? r.activeNameEmogy ?? null,
}));

    if (!cancelled) {
      setLeaderboardEntries(cleaned);
      setTotal(Number.isFinite(totalFromApi) ? totalFromApi : cleaned.length);
    }
  } catch (err) {
    console.error(err);
    if (!cancelled) {
      setLeaderboardEntries([]);
      setLeaderboardError("Could not load recruiters leaderboard.");
    }
  } finally {
    if (!cancelled) setLeaderboardLoading(false);
  }
}

    if (view === "leaderboard") {
      loadRecruiters();
    }

    return () => {
      cancelled = true;
    };
  }, [view, page, pageSize]);

  useEffect(() => {
    let cancelled = false;

    async function loadMyRecruiterRank() {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/season-stats/recruiters-leaderboard/my-rank`;

    const res = await fetch(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    const json = await res.json();

    if (!cancelled) {
      setMyRecruiterRank(json?.rank != null ? json : { ...json, rank: null });
    }
  } catch (err) {
    console.error(err);
    if (!cancelled) setMyRecruiterRank(null);
  }
}

    if (view === "leaderboard") {
      loadMyRecruiterRank();
    }

    return () => {
      cancelled = true;
    };
  }, [view]);

  useEffect(() => {
  let cancelled = false;

  async function loadFriends() {
    setFriendsLoading(true);
    setFriendsError("");

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/friends`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || "Failed to fetch referrals");
      }

      if (!cancelled) {
        setFriends(data.referredFriends || []);
        setPendingRewards({
          sparks: Number(data?.pendingSparks ?? 0) || 0,
          runes: Number(data?.pendingRunes ?? 0) || 0,
        });

setReferralsStreak({
  enabled: !!data?.referralsStreak?.enabled,
  startDate: data?.referralsStreak?.startDate ?? null,
  endDate: data?.referralsStreak?.endDate ?? null,
  priceRunes: Number(data?.referralsStreak?.priceRunes ?? 0) || 0,
  milestoneCount: Number(data?.referralsStreak?.milestoneCount ?? 0) || 0,
  itemId: data?.referralsStreak?.itemId ?? null,
  itemName: data?.referralsStreak?.itemName ?? null,
  itemType: data?.referralsStreak?.itemType ?? null,
  reward: data?.referralsStreak?.reward ?? null,
  seasonNumber: data?.referralsStreak?.seasonNumber ?? null,
  progress: Number(data?.referralsStreak?.progress ?? 0) || 0,
  claimed: !!data?.referralsStreak?.claimed,
  claimable: !!data?.referralsStreak?.claimable,
  milestones: Array.isArray(data?.referralsStreak?.milestones)
    ? data.referralsStreak.milestones
    : [],
});

        const code = String(data?.referralCode || "").trim();
        const botUsername = process.env.REACT_APP_TELEGRAM_BOT_USERNAME || "taptopiaio_bot";
        const link = code
          ? `https://t.me/${botUsername}?startapp=${encodeURIComponent(code)}`
          : "";

        setReferralLink(link);
      }
    } catch (err) {
      console.error(err);
      if (!cancelled) {
        setFriends([]);
        setPendingRewards({ sparks: 0, runes: 0 });
        setFriendsError("Failed to load your referrals.");
        setReferralsStreak({
  enabled: false,
  startDate: null,
  endDate: null,
  priceRunes: 0,
  milestoneCount: 0,
  itemId: null,
  itemName: null,
  itemType: null,
  reward: null,
  seasonNumber: null,
  progress: 0,
  claimed: false,
  claimable: false,
  milestones: [],
});
      }
    } finally {
      if (!cancelled) setFriendsLoading(false);
    }
  }

  loadFriends();

  return () => {
    cancelled = true;
  };
}, []);

const [claimStreakLoading, setClaimStreakLoading] = useState(false);

async function handleClaimStreak() {
  if (!referralsStreak.claimable || claimStreakLoading) return;

  try {
    setClaimStreakLoading(true);

    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/friends/claim-streak`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data?.error || "Failed to claim streak reward");
    }

    setReferralsStreak({
      enabled: !!data?.referralsStreak?.enabled,
      startDate: data?.referralsStreak?.startDate ?? null,
      endDate: data?.referralsStreak?.endDate ?? null,
      priceRunes: Number(data?.referralsStreak?.priceRunes ?? 0) || 0,
      milestoneCount: Number(data?.referralsStreak?.milestoneCount ?? 0) || 0,
      itemId: data?.referralsStreak?.itemId ?? null,
      itemName: data?.referralsStreak?.itemName ?? null,
      itemType: data?.referralsStreak?.itemType ?? null,
      reward: data?.referralsStreak?.reward ?? null,
      seasonNumber: data?.referralsStreak?.seasonNumber ?? null,
      progress: Number(data?.referralsStreak?.progress ?? 0) || 0,
      claimed: !!data?.referralsStreak?.claimed,
      claimable: !!data?.referralsStreak?.claimable,
      milestones: Array.isArray(data?.referralsStreak?.milestones)
        ? data.referralsStreak.milestones
        : [],
    });

    setClaimedStreakReward({
      itemId: data?.claimedItem?.itemId ?? null,
      itemName: data?.claimedItem?.itemName ?? "Reward",
      itemType: data?.claimedItem?.itemType ?? null,
      reward: data?.claimedItem?.reward ?? null,
    });

    setShowClaimStreakSuccessModal(true);

    setUser?.((prev) => ({
  ...prev,
  sparks: Number(data?.user?.sparks ?? prev?.sparks ?? 0),
  runes: Number(data?.user?.runes ?? prev?.runes ?? 0),
}));
  } catch (err) {
    console.error(err);
    setClaimErrorMessage(err.message || "Failed to claim streak reward");
    setShowClaimErrorModal(true);
  } finally {
    setClaimStreakLoading(false);
  }
}

async function handleCopyReferralLink() {
  if (!referralLink) return;

  try {
    await navigator.clipboard.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  } catch (err) {
    console.error("Failed to copy referral link", err);
  }
}

const handleShareReferral = async () => {
  const tg = window.Telegram?.WebApp;

  if (!referralLink) return;

  if (!tg?.initDataUnsafe?.user?.id || typeof tg.shareMessage !== "function") {
    try {
      await navigator.clipboard.writeText(referralLink);
      console.log("Telegram not available, referral link copied instead");
    } catch (e) {
      console.error("fallback copy failed", e);
    }
    return;
  }

  const rawRef =
    referralLink.includes("startapp=")
      ? referralLink.split("startapp=")[1]?.split("&")[0]
      : referralLink;

  let response;
  try {
    response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/telegram/prepare-message`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          userId: tg.initDataUnsafe.user.id,
          referralCode: rawRef,
        }),
      }
    );
  } catch (e) {
    console.error("prepare-message request failed", e);
    return;
  }

  let data = {};
  try {
    data = await response.json();
  } catch (e) {
    console.error("prepare-message invalid json", e);
    return;
  }

  if (!response.ok || !data?.preparedMessageId) {
    console.error("prepare-message failed", data);
    return;
  }

  try {
    tg.shareMessage(data.preparedMessageId, (success) => {
      console.log("shareMessage result:", success);
    });
  } catch (e) {
    console.error("Telegram shareMessage failed", e);
  }
};

  const handleClaimRewards = async (rewardType) => {
  if (claimLoading) return;

  const currentPendingSparks = Number(pendingRewards?.sparks || 0);
  const currentPendingRunes = Number(pendingRewards?.runes || 0);

  if (rewardType === "sparks" && currentPendingSparks <= 0) {
    setClaimErrorMessage("You have no pending sparks to claim.");
    setShowClaimErrorModal(true);
    return;
  }

  if (rewardType === "runes" && currentPendingRunes <= 0) {
    setClaimErrorMessage("You have no pending runes to claim.");
    setShowClaimErrorModal(true);
    return;
  }

  try {
    setClaimLoading(true);

    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/friends/claim`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        type: rewardType, // "sparks" or "runes"
      }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data?.error || "Failed to claim rewards");
    }

    setPendingRewards((prev) => ({
      sparks:
        rewardType === "sparks"
          ? 0
          : Number(data?.remainingPendingSparks ?? prev.sparks ?? 0),
      runes:
        rewardType === "runes"
          ? 0
          : Number(data?.remainingPendingRunes ?? prev.runes ?? 0),
    }));

    setClaimedRewards({
      sparks: Number(data?.claimedSparks ?? 0) || 0,
      runes: Number(data?.claimedRunes ?? 0) || 0,
    });

    setUser?.((prev) => ({
  ...prev,
  sparks: Number(data?.user?.sparks ?? prev?.sparks ?? 0),
  runes: Number(data?.user?.runes ?? prev?.runes ?? 0),
}));

    setShowClaimSuccessModal(true);
  } catch (err) {
    console.error(err);
    setClaimErrorMessage(err.message || "Failed to claim rewards");
    setShowClaimErrorModal(true);
  } finally {
    setClaimLoading(false);
  }
};

  return (
  <div
    className="shop-container"
    style={{
      backgroundColor: "#000",
      overflowX: "hidden",
      backgroundImage: "url('/bricks.png')",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      paddingLeft: 0,
      paddingRight: 0,
    }}
  >
    <div
      style={{
        width: "100%",
        height: "80px",
        marginTop: -18,
        backgroundImage: "url('/friendsbg.png')",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 10,
        boxSizing: "border-box",
      }}
    >
      <div className="text-outline-white" style={{ fontSize: 32 }}>
        Referrals
      </div>
    </div>

    <div
      style={{
        width: "100%",
        maxWidth: 430,
        margin: "0 auto",
        paddingLeft: 15,
        paddingRight: 15,
        boxSizing: "border-box",
        overflowX: "hidden",
      }}
    >
      <img
        src="/pending.png"
        style={{ maxWidth: "300px", marginBottom: 15 }}
        alt=""
      />

          <div style={statGrid}>
            <div
              style={{
                ...statStyle2,
                cursor: pendingRewards.sparks > 0 ? "pointer" : "default",
                opacity: claimLoading ? 0.7 : 1,
              }}
              onClick={() => handleClaimRewards("sparks")}
            >
              {pendingRewards.sparks > 0 && (
                <img
                  src="/claim.png"
                  style={{ position: "absolute", top: "-10px" }}
                  alt=""
                />
              )}

              <div
                style={{
                  marginTop: pendingRewards.sparks > 0 ? 10 : 0,
                  fontSize: 24,
                }}
              >

                <img
                  src="/sparks.png"
                  style={{ height: 21, marginTop: "-3px", verticalAlign: "middle" }}
                  alt=""
                />{" "}
                {pendingRewards.sparks}
              </div>
              <span style={{ marginTop: "-5px", fontSize: 18, color: "#FFC97F" }}>
                Sparks
              </span>
            </div>

            <div
              style={{
                ...statStyle2,
                cursor: pendingRewards.runes > 0 ? "pointer" : "default",
                opacity: claimLoading ? 0.7 : 1,
              }}
              onClick={() => handleClaimRewards("runes")}
            >

              {pendingRewards.runes > 0 && (
                <img
                  src="/claim.png"
                  style={{ position: "absolute", top: "-10px" }}
                  alt=""
                />
              )}

              <div
                style={{
                  marginTop: pendingRewards.runes > 0 ? 10 : 0,
                  fontSize: 24,
                }}
              >
                <img
                  src="/runes.png"
                  style={{ height: 21, marginTop: "-3px", verticalAlign: "middle" }}
                  alt=""
                />{" "}
                {pendingRewards.runes}
              </div>
              <span style={{ marginTop: "-5px", fontSize: 18, color: "#FFC97F" }}>
                Runes
              </span>
            </div>
          </div>

          <div style={{ width: "100%", maxWidth: 400, margin: "15px auto 0" }}>
            <div
              style={{
                borderRadius: "12px",
                backgroundColor: "#561300",
                overflow: "hidden",
                position: "relative"
              }}
            >
              <div
                style={{
                  borderTop: "1px solid #FFC97F",
                  padding: 10,
                  borderRadius: "12px",
                  backgroundColor: "#411103",
                  color: "#FFC97F",
                  fontSize: 21,
                }}
              >
                <img
                  src="/important.png"
                  style={{
                    marginTop: "-3px",
                    marginRight: 3,
                    verticalAlign: "middle",
                    height: "20px",
                  }}
                  alt=""
                />{" "}
                How It Works
              </div>

              <div style={{ padding: 10, color: "#FFF", fontSize: 18,lineHeight: "25px" }}>
                10% Commission from your friends' Battle profits.
                <br />
                10% Bonus from your friends' Rune purchases.

                <div
                  style={{
                    marginTop: 12,
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      flex: 1,
                    }}
                  >
                    <input
                      value={referralLink}
                      readOnly
                      placeholder="Loading referral link..."
                      style={{
                        width: "100%",
                        padding: "10px 36px 10px 10px",
                        height: "38px",
                        boxSizing: "border-box",
                        borderRadius: "8px",
                        border: "none",
                        outline: "none",
                        color: "#000",
                        backgroundColor: "transparent",
                        backgroundImage: "url('/invite.png')",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        fontWeight: "bold",
                        fontSize: 16,
                      }}
                    />

                    {copied && (
                      <div
                        style={{
                          marginTop: 6,
                          fontSize: 14,
                          color: "#7CFF5B",
                          textShadow: "1px 1px #000",
                          position: "absolute",
                          top: -25,
                          right: 0,
                          backgroundColor: "#000",
                          padding: "3px 10px",
                          borderRadius: 12
                        }}
                      >
                        Referral link copied!
                      </div>
                    )}

                    <img
                      src="/copy.png"
                      onClick={handleCopyReferralLink}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        height: "21px",
                        opacity: 0.8,
                        cursor: referralLink ? "pointer" : "default",
                      }}
                      alt=""
                    />
                  </div>

                  <input
                    type="button"
                    value="Share"
                    onClick={handleShareReferral}
                    style={{
                      backgroundColor: "transparent",
                      width: "84px",
                      height: "38px",
                      padding: "10px",
                      boxSizing: "border-box",
                      borderRadius: "8px",
                      border: "none",
                      cursor: referralLink ? "pointer" : "default",
                      fontWeight: "bold",
                      color: "#FFC97F",
                      backgroundImage: "url('/share.png')",
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      flexShrink: 0,
                      opacity: referralLink ? 1 : 0.6,
                    }}
                  />
                </div>
            </div>
          </div>

          {referralsStreak.enabled && referralsStreak.milestoneCount > 0 && (
  <div style={{ width: "100%", maxWidth: 400, margin: "10px auto 0", padding: 5, boxSizing: "border-box" }}>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        width: "100%",
      }}
    >
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: 12,
          backgroundColor: "#1A0101",
          border: "4px solid #444",
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <img src="/hand.png" alt="" style={{ height: 32 }} />
      </div>

      <div
        style={{
          position: "relative",
          flex: 1,
          height: 64,
          borderRadius: 12,
          backgroundColor: "#222222",
          borderBottom: "3px solid #444",
          boxSizing: "border-box",
          padding: "8px 10px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 8,
          }}
        >
          <div style={{ lineHeight: 1.1 }}>
            <div
              style={{
                color: "#fff",
                fontSize: 18,
                textShadow: "1px 1px #000",
                color: "#FFC97F"
              }}
            >
              {referralsStreak.milestoneCount} Invites: <span style={{color: "#fff"}}>{referralsStreak.itemName}</span>
            </div>
            
          </div>

          <div
            onClick={handleClaimStreak}
            style={{
              minWidth: 48,
              height: 21,
              lineHeight: "21px",
              textAlign: "center",
              borderRadius: 8,
              cursor:
                referralsStreak.claimable && !referralsStreak.claimed && !claimStreakLoading
                  ? "pointer"
                  : "default",
              color: "#fff",
              fontSize: 16,
              textShadow: "1px 1px #000",
              background:
                referralsStreak.claimable && !referralsStreak.claimed
                  ? "linear-gradient(180deg, #7CFF5B 0%, #38A51E 100%)"
                  : "#555",
              opacity: claimStreakLoading ? 0.7 : 1,
            }}
          >
            {referralsStreak.claimed ? "DONE" : "CLAIM"}
          </div>
        </div>

        <div
          style={{
            position: "absolute",
            left: 10,
            right: 10,
            bottom: 8,
            height: 18,
            borderRadius: 9,
            backgroundColor: "#000",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: `${
                referralsStreak.milestoneCount > 0
                  ? Math.min(
                      100,
                      (referralsStreak.progress / referralsStreak.milestoneCount) * 100
                    )
                  : 0
              }%`,
              height: "100%",
              borderRadius: 9,
              background: "linear-gradient(90deg, #BF1515 0%, #FD8700 100%)",
            }}
          />
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: 14,
              textShadow: "1px 1px #000",
            }}
          >
            {referralsStreak.progress}/{referralsStreak.milestoneCount}
          </div>
        </div>
      </div>
    </div>
  </div>
)}

          <div style={{ width: "100%", maxWidth: 400, margin: "10px auto 0" }}>
            <div
              style={{
                display: "flex",
                width: "100%",
                gap: 6,
                fontSize: 21,
              }}
            >
              <div
                onClick={() => {
                  setView("leaderboard");
                  setPage(1);
                }}
                style={{
                  flex: 1,
                  borderRadius: 12,
                  height: 42,
                  lineHeight: "42px",
                  textAlign: "center",
                  cursor: "pointer",
                  backgroundColor: view === "leaderboard" ? "#DF5600" : "#532102",
                  color: "#fff",
                  textShadow: "1px 1px #000",
                }}
              >
                Leaderboard
              </div>

              <div
                onClick={() => setView("referrals")}
                style={{
                  flex: 1,
                  borderRadius: 12,
                  height: 42,
                  lineHeight: "42px",
                  textAlign: "center",
                  cursor: "pointer",
                  backgroundColor: view === "referrals" ? "#DF5600" : "#532102",
                  color: "#fff",
                  textShadow: "1px 1px #000",
                }}
              >
                Referrals
              </div>
            </div>
          </div>

          <div
  style={{
    width: "100%",
    maxWidth: 400,
    minWidth: 0,
    margin: "15px auto 0px",
    boxSizing: "border-box",
    overflowX: "hidden",
  }}
>
            {view === "leaderboard" && (
              <>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 0,
                    marginBottom: 15,
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 10,
                      padding: "8px 12px",
                      borderRadius: 18,
                      background: "rgba(0,0,0,0.45)",
                      border: "1px solid #555",
                      color: "#ffcc62",
                      textShadow: "1px 1px #000",
                      fontSize: 16,
                      boxSizing: "border-box",
                    }}
                  >
                    {myRecruiterRank?.rank != null ? (
                      <>
                        <span>
                          <b>Your Rank:</b>{" "}
                          <span style={{ fontWeight: "bold", color: "#fff" }}>
                            #{myRecruiterRank.rank}
                          </span>
                        </span>
                        <span style={{ opacity: 0.85 }}>
                          ({myRecruiterRank?.recruits ?? 0} Recruits)
                        </span>
                      </>
                    ) : (
                      <span>No rank yet — refer at least one player to enter the board.</span>
                    )}
                  </div>
                </div>

                {leaderboardLoading ? (
                  <div style={{ color: "#fff", textAlign: "center" }}>Loading Leaderboard...</div>
                ) : leaderboardError ? (
                  <div style={{ color: "#ff8080", textAlign: "center" }}>{leaderboardError}</div>
                ) : (
                  leaderboardEntries.map((entry, idx) => {
                    const offset = (page - 1) * pageSize;
const globalIdx = offset + idx;
const rankLabel = getRankIcon(globalIdx);

const rankLength = String(rankLabel).length;
const rankFontSize =
  rankLength > 4 ? 14 :
  rankLength > 3 ? 16 :
  20;

const bannerSrc = cosmeticAssetSrc(entry.activeNameBanner);
const emogySrc = cosmeticAssetSrc(entry.activeNameEmogy);
const nameStyle = getNameStyleCSS(entry.activeNameStyle);

return (
                      <motion.div
                        key={entry.id ?? idx}
                        className="task-card"
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3, delay: idx * 0.05 }}
                        style={{
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  backgroundImage: bannerSrc
    ? `linear-gradient(rgba(0,0,0,0.28), rgba(0,0,0,0.28)), url('${bannerSrc}')`
    : "url('/task_rect.png')",
  backgroundSize: bannerSrc ? "cover" : "100% 56px",
  backgroundRepeat: "repeat",
  backgroundPosition: "center",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "10px 14px",
  marginBottom: 8,
  overflow: "hidden",
  boxShadow: bannerSrc ? "0 4px 12px rgba(0,0,0,0.45)" : undefined,
}}
                      >
                        <span
  style={{
    minWidth: 36,
    width: 36,
    height: 36,
    textAlign: "center",
    fontSize: rankFontSize,
    color: "#fff",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
>
  {globalIdx <= 2 ? (
    <img
      src={rankLabel}
      alt={`Rank ${globalIdx + 1}`}
      style={{
        width: 34,
        height: 34,
        objectFit: "contain",
        display: "block",
      }}
      draggable={false}
    />
  ) : (
    rankLabel
  )}
</span>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            flex: 1,
                            minWidth: 0,
                            overflow: "hidden",
                          }}
                        >
                          <b
                            style={{
                              lineHeight: "32px",
                              borderRadius: "8px",
                              display: "inline-block",
                              backgroundColor: "#000",
                              width: "32px",
                              height: "32px",
                              overflow: "hidden",
                              position: "relative",
                              flex: "0 0 32px",
                            }}
                          >
                            <img
                              src={entry.avatar || svgFallback(entry.username)}
                              alt=""
                              style={{
                                border: entry?.early_bird ? "1px solid #FFD700" : "0px",
                                borderRadius: "8px",
                                boxSizing: "border-box",
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                display: "block",
                              }}
                            />

                            {entry?.early_bird && (
                              <img
                                src="/whitelist.png"
                                style={{
                                  position: "absolute",
                                  bottom: "1px",
                                  right: "1px",
                                  width: "15px",
                                  height: "15px",
                                }}
                                alt=""
                              />
                            )}

                            {entry?.gamepass_active && (
                              <img
                                src="/passicon.png"
                                style={{
                                  position: "absolute",
                                  bottom: "1px",
                                  left: "1px",
                                  width: "15px",
                                  height: "15px",
                                }}
                                alt=""
                              />
                            )}
                          </b>

                         <span
  style={{
    fontSize: "21px",
    color: entry.gamepass_active ? "#EA5702" : "#ffcc62",
    textShadow: "1px 1px #000",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    gap: 6,
    ...nameStyle,
  }}
  title={entry.username}
>
  {emogySrc && (
    <img
      src={emogySrc}
      alt=""
      draggable={false}
      style={{
        width: 22,
        height: 22,
        objectFit: "contain",
        flexShrink: 0,
      }}
    />
  )}

  <span
    style={{
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }}
  >
    {truncateUsername(entry.username)}
  </span>
</span>
                        </div>

                        <div
                          style={{
                            fontSize: "21px",
                            backgroundImage: "url('/recruits.png')",
                            backgroundSize: "21px 21px",
                            paddingLeft: "26px",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "left center",
                            color: "#fff",
                            textShadow: "1px 1px #000",
                            whiteSpace: "nowrap",
                            flexShrink: 0,
                          }}
                        >
                          {entry.recruits} Recruits
                        </div>
                      </motion.div>
                    );
                  })
                )}
              </>
            )}

            {view === "referrals" && (
              <>
                {friendsLoading ? (
                  <p style={{ color: "#fff", textAlign: "center" }}>Loading...</p>
                ) : friendsError ? (
                  <p style={{ color: "#ff8080", textAlign: "center" }}>{friendsError}</p>
                ) : friends.length === 0 ? (
                  <p style={{ color: "#fff", textAlign: "center" }}>No referrals yet. Share your code!</p>
                ) : (
                  friends.map((friend, idx) => (
                    <motion.div
                      key={idx}
                      className="task-card"
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.3, delay: idx * 0.05 }}
                      style={{
                        width: "100%",
                        boxSizing: "border-box",
                        backgroundImage: "url('/task_rect.png')",
                        backgroundSize: "100% 56px",
                        backgroundRepeat: "repeat",
                        backgroundPosition: "center bottom",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "10px",
                        padding: "10px 14px",
                        marginBottom: 8,
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          minWidth: 0,
                          flex: 1,
                          overflow: "hidden",
                        }}
                      >
                        <b
                          style={{
                            overflow: "hidden",
                            lineHeight: "32px",
                            borderRadius: "8px",
                            display: "inline-block",
                            backgroundColor: "#000",
                            width: "32px",
                            height: "32px",
                            flex: "0 0 32px",
                          }}
                        >
                          <img
                            src={friend.avatarUrl || svgFallback(friend.name)}
                            alt=""
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              display: "block",
                            }}
                            loading="lazy"
                          />
                        </b>

                        <span
                          style={{
                            fontSize: "24px",
                            color: "#ffcc62",
                            textShadow: "1px 1px #000",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            minWidth: 0,
                          }}
                        >
                          {friend.name}
                        </span>
                      </div>

                      <div
                        style={{
                          fontSize: "20px",
                          backgroundImage: "url('/calendar.png')",
                          backgroundSize: "24px",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "left center",
                          paddingLeft: "30px",
                          color: "#fff",
                          textShadow: "1px 1px #000",
                          whiteSpace: "nowrap",
                          flexShrink: 0,
                        }}
                      >
                        {friend.created_at
                          ? new Date(friend.created_at).toLocaleDateString("de-DE")
                          : "—"}
                      </div>
                    </motion.div>
                  ))
                )}
              </>
            )}

          {view === "leaderboard" && (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      width: "100%",
      padding: "0 10px",
      boxSizing: "border-box",
      margin: "20px 0 4px",
    }}
  >
    <button
      disabled={page <= 1}
      onClick={() => setPage(1)}
      style={{
        backgroundColor: page <= 1 ? "#444" : "#ffcc62",
        color: page <= 1 ? "#888" : "#000",
        border: "none",
        borderRadius: 10,
        width: 38,
        height: 38,
        fontSize: 18,
        cursor: page <= 1 ? "not-allowed" : "pointer",
        boxShadow: page <= 1 ? "none" : "0 0 6px #ffcc62",
        flex: "0 0 38px",
      }}
    >
      ⏮
    </button>

    <button
      disabled={page <= 1}
      onClick={() => setPage((p) => Math.max(1, p - 1))}
      style={{
        backgroundColor: page <= 1 ? "#444" : "#ffcc62",
        color: page <= 1 ? "#888" : "#000",
        border: "none",
        borderRadius: 10,
        width: 38,
        height: 38,
        fontSize: 18,
        cursor: page <= 1 ? "not-allowed" : "pointer",
        boxShadow: page <= 1 ? "none" : "0 0 6px #ffcc62",
        flex: "0 0 38px",
      }}
    >
      ◀
    </button>

    <span
      style={{
        color: "#ffcc62",
        textShadow: "1px 1px #000",
        fontSize: 17,
        textAlign: "center",
        padding: "6px 10px",
        borderRadius: 10,
        background: "rgba(0,0,0,0.35)",
        border: "1px solid #555",
        whiteSpace: "nowrap",
        flex: "1 1 auto",
        minWidth: 0,
      }}
    >
      Page {page} / {totalPages}
    </span>

    <button
      disabled={page >= totalPages}
      onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
      style={{
        backgroundColor: page >= totalPages ? "#444" : "#ffcc62",
        color: page >= totalPages ? "#888" : "#000",
        border: "none",
        borderRadius: 10,
        width: 38,
        height: 38,
        fontSize: 18,
        cursor: page >= totalPages ? "not-allowed" : "pointer",
        boxShadow: page >= totalPages ? "none" : "0 0 6px #ffcc62",
        flex: "0 0 38px",
      }}
    >
      ▶
    </button>

    <button
      disabled={page >= totalPages}
      onClick={() => setPage(totalPages)}
      style={{
        backgroundColor: page >= totalPages ? "#444" : "#ffcc62",
        color: page >= totalPages ? "#888" : "#000",
        border: "none",
        borderRadius: 10,
        width: 38,
        height: 38,
        fontSize: 18,
        cursor: page >= totalPages ? "not-allowed" : "pointer",
        boxShadow: page >= totalPages ? "none" : "0 0 6px #ffcc62",
        flex: "0 0 38px",
      }}
    >
      ⏭
    </button>
  </div>
)}
          </div>
        </div>
      </div>

{showClaimSuccessModal && (
  <div className="modal-backdrop">
    <motion.div
      className="modal fancy-success-modal"
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
    >
      <img
        src="/finger.png"
        alt="Success"
        style={{ height: "80px", marginBottom: "10px" }}
      />

      <h2 style={{ color: "#32cd32", marginBottom: "10px" }}>
        Rewards Claimed!
      </h2>

      <p
        style={{
          textShadow: "1px 1px #000",
          fontSize: "22px",
          color: "#ddd",
          marginBottom: "14px",
        }}
      >
        You Claimed:
      </p>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 12,
          marginBottom: 10,
        }}
      >
        {claimedRewards.sparks > 0 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              fontSize: 26,
              color: "#FFC97F",
              textShadow: "1px 1px #000",
              fontWeight: "bold",
            }}
          >
            <img
              src="/sparks.png"
              alt="Sparks"
              style={{ height: 28, width: 28, objectFit: "contain" }}
            />
            <span>{claimedRewards.sparks}</span>
          </div>
        )}

        {claimedRewards.runes > 0 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              fontSize: 26,
              color: "#FFC97F",
              textShadow: "1px 1px #000",
              fontWeight: "bold",
            }}
          >
            <img
              src="/runes.png"
              alt="Runes"
              style={{ height: 28, width: 28, objectFit: "contain" }}
            />
            <span>{claimedRewards.runes}</span>
          </div>
        )}
      </div>

      <div className="modal-footer">
        <button
          onClick={() => {
            setShowClaimSuccessModal(false);
            setClaimedRewards({ sparks: 0, runes: 0 });
          }}
          style={{ marginTop: "10px" }}
        >
          Close
        </button>
      </div>
    </motion.div>
  </div>
)}

{showClaimErrorModal && (
  <div className="modal-backdrop">
    <motion.div
      className="modal fancy-success-modal"
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
    >
      <img
        src="/finger.png"
        alt="Error"
        style={{
          height: "80px",
          marginBottom: "10px",
          transform: "rotate(180deg)",
        }}
      />

      <h2 style={{ color: "#ff4d4d", marginBottom: "10px" }}>
        Claim Failed
      </h2>

      <p
        style={{
          textShadow: "1px 1px #000",
          fontSize: "22px",
          color: "#ddd",
        }}
      >
        {claimErrorMessage}
      </p>

      <div className="modal-footer">
        <button
          onClick={() => {
            setShowClaimErrorModal(false);
            setClaimErrorMessage("");
          }}
          style={{ marginTop: "10px" }}
        >
          Close
        </button>
      </div>
    </motion.div>
  </div>
)}

{showClaimStreakSuccessModal && (
  <div className="modal-backdrop">
    <motion.div
      className="modal fancy-success-modal"
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
      style={{ textAlign: "center" }}
    >
      <img
        src={claimedStreakReward?.reward?.icon || "/pack.png"}
        alt={claimedStreakReward?.itemName || "Reward"}
        style={{ height: "80px", marginBottom: "10px", objectFit: "contain" }}
      />

      <h2 style={{ color: "#32cd32", marginBottom: "10px" }}>
        Streak Claimed!
      </h2>

      <p
        style={{
          textShadow: "1px 1px #000",
          fontSize: "20px",
          color: "#ddd",
          marginBottom: "8px",
        }}
      >
        You Received:
      </p>

      <div
        style={{
          color: "#FFC97F",
          fontSize: "24px",
          fontWeight: "bold",
          textShadow: "1px 1px #000",
          marginBottom: "14px",
        }}
      >
        {claimedStreakReward?.itemName || "Reward"}
      </div>

      <div className="modal-footer">
        <button
          onClick={() => {
            setShowClaimStreakSuccessModal(false);
            setClaimedStreakReward({
              itemId: null,
              itemName: "",
              itemType: null,
              reward: null,
            });
          }}
          style={{ marginTop: "10px" }}
        >
          Close
        </button>
      </div>
    </motion.div>
  </div>
)}

    </div>
  );
}